/* LILOVA BOOST : apparitions, étincelles panier, toast, barre livraison, comptes à rebours Noël */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastClick = null;
  document.addEventListener('pointerdown', function (e) {
    var b = e.target.closest && e.target.closest('button, [type="submit"], a');
    if (b) lastClick = b;
  }, true);

  /* ---------- Apparition au défilement ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.lb-reveal:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -30px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Étincelles ---------- */
  var colors = ['#e28a94', '#ffd6e6', '#5a1626', '#f2b544', '#ffb3cc'];
  function burst(x, y) {
    if (reduce) return;
    for (var i = 0; i < 16; i++) {
      var s = document.createElement('span');
      var star = i % 3 === 0;
      s.className = 'lb-spark' + (star ? ' lb-spark--star' : '');
      if (star) s.textContent = i % 2 ? '✦' : '♥';
      var a = (Math.PI * 2 * i) / 16 + Math.random() * 0.4;
      var d = 40 + Math.random() * 60;
      s.style.left = x + 'px'; s.style.top = y + 'px';
      s.style.setProperty('--x', Math.cos(a) * d + 'px');
      s.style.setProperty('--y', Math.sin(a) * d - 20 + 'px');
      s.style.setProperty('--r', (Math.random() * 360) + 'deg');
      s.style.setProperty('--c', colors[i % colors.length]);
      document.body.appendChild(s);
      setTimeout(function (n) { n.remove(); }, 950, s);
    }
  }
  function bumpCart() {
    var ico = document.querySelector('.lh [data-open="cart"]') || document.getElementById('cart-icon-bubble');
    if (!ico || reduce) return;
    ico.classList.remove('lb-bump'); void ico.offsetWidth; ico.classList.add('lb-bump');
  }

  /* ---------- Toast ---------- */
  var toast, toastT;
  function showToast(main, sub) {
    if (!toast) { toast = document.createElement('div'); toast.className = 'lb-toast'; toast.setAttribute('role', 'status'); document.body.appendChild(toast); }
    toast.innerHTML = '<span aria-hidden="true">💗</span><span>' + main + (sub ? '<small>' + sub + '</small>' : '') + '</span>';
    requestAnimationFrame(function () { toast.classList.add('is-on'); });
    clearTimeout(toastT); toastT = setTimeout(function () { toast.classList.remove('is-on'); }, 3200);
  }

  /* ---------- Livraison offerte ---------- */
  function threshold() {
    var h = document.querySelector('[data-lilova-header]');
    var t = h ? parseFloat(h.getAttribute('data-free-ship')) : 50;
    return isNaN(t) ? 50 : t;
  }
  function euros(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function updateShip(total) {
    var t = threshold() * 100;
    document.querySelectorAll('[data-lb-ship]').forEach(function (el) {
      if (!t) { el.hidden = true; return; }
      var txt = el.querySelector('[data-lb-ship-text]'), fill = el.querySelector('.lb-ship__fill');
      var left = t - total;
      if (total <= 0) txt.innerHTML = '🚚 <strong>Livraison offerte</strong> dès ' + euros(t).replace(',00', '') + " d'achat";
      else if (left <= 0) txt.innerHTML = '🎉 <strong>Bravo, la livraison est offerte !</strong>';
      else txt.innerHTML = '🚚 Plus que <strong>' + euros(left) + '</strong> pour la <strong>livraison offerte</strong>';
      if (fill) fill.style.setProperty('--p', Math.min(100, (total / t) * 100) + '%');
    });
    return t ? t - total : 0;
  }
  function refreshCart(celebrate) {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      var left = updateShip(c.total_price);
      if (celebrate) {
        var sub = left > 0 ? 'Plus que ' + euros(left) + ' pour la livraison offerte' : 'Livraison offerte sur ta commande ✨';
        showToast('Ajouté à ton panier !', sub);
      }
    }).catch(function () {});
  }

  /* ---------- Détection "ajout au panier" (sans casser le thème) ---------- */
  function onAdded() {
    if (lastClick && document.contains(lastClick)) {
      var r = lastClick.getBoundingClientRect();
      burst(r.left + r.width / 2, r.top + r.height / 2);
    }
    bumpCart();
    setTimeout(function () { refreshCart(true); }, 150);
  }
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (res) { if (res && res.ok) onAdded(); }).catch(function () {});
      }
      return p;
    };
  }

  /* ---------- Compte à rebours Noël ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  var cdTimer = null;
  function initCountdowns() {
    var clocks = document.querySelectorAll('[data-lb-deadline]');
    if (!clocks.length) return;
    function tick() {
      var now = Date.now();
      clocks.forEach(function (el) {
        var end = new Date(el.getAttribute('data-lb-deadline')).getTime();
        var host = el.closest('[data-lb-noel]') || el;
        var diff = end - now;
        if (isNaN(end) || diff <= 0) { host.classList.add('is-over'); var o = host.querySelector('[data-lb-over]'); if (o) o.hidden = false; var b = host.querySelector('[data-lb-before]'); if (b) b.hidden = true; return; }
        var d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24, m = Math.floor(diff / 6e4) % 60, s = Math.floor(diff / 1e3) % 60;
        var set = function (k, v) { var n = el.querySelector('[data-' + k + ']'); if (n) n.textContent = v; };
        set('d', d); set('h', pad(h)); set('m', pad(m)); set('s', pad(s));
      });
    }
    tick(); clearInterval(cdTimer); cdTimer = setInterval(tick, 1000);
  }
  /* Lignes "Commande avant le…" : masquées après la date */
  function initNoelLines() {
    document.querySelectorAll('[data-lb-until]').forEach(function (el) {
      var end = new Date(el.getAttribute('data-lb-until')).getTime();
      if (!isNaN(end) && Date.now() > end) el.hidden = true;
    });
  }

  /* Lien "avis" -> section avis de la page */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-lb-to-reviews]');
    if (!a) return;
    var t = document.querySelector('[id$="lilova_avis_pdp"]') || document.querySelector('[id*="lilova_avisv2"]');
    if (t) { e.preventDefault(); t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }
  });

  function init() {
    initReveal();
    initCountdowns();
    initNoelLines();
    if (document.querySelector('[data-lb-ship]')) refreshCart(false);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initCountdowns(); });
})();
